<template>
  <OverviewCard
    :title="$t('key_dashboard_shipments_by_courier')"
    :loading="loading"
    :error="error"
    :empty="!data.total"
  >
    <div v-for="item in data.items" :key="item.key" class="courier-row">
      <span class="courier-badge" :style="{ backgroundColor: item.color }">{{ badge(item) }}</span>
      <span class="text-xs courier-name text-truncate" :title="name(item)">{{ name(item) }}</span>
      <MeterBar class="flex-grow-1 mx-2" :value="item.percent" />
      <span class="text-xs font-weight-bold courier-percent">{{ percent(item.percent) }}</span>
    </div>
  </OverviewCard>
</template>

<script>
import MeterBar from "./MeterBar.vue";
import OverviewCard from "./OverviewCard.vue";
import { formatPercent } from "./shared";

// Name, initials and colour come from the courier records of the admin; the
// back gives unregistered codes a default look. OTHERS and NO_COURIER have no
// name, the front labels them.
const SPECIAL_LABELS = {
  OTHERS: "key_dashboard_others",
  NO_COURIER: "key_dashboard_no_courier",
};

export default {
  name: "ShipmentsByCourier",
  components: { MeterBar, OverviewCard },
  props: {
    data: { type: Object, default: () => ({ total: 0, items: [] }) },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
  },
  methods: {
    name(item) {
      return SPECIAL_LABELS[item.key] ? this.$t(SPECIAL_LABELS[item.key]) : item.name;
    },
    badge(item) {
      return item.initials || "··";
    },
    percent(value) {
      return formatPercent(value, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.courier-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.9rem;
}

.courier-badge {
  min-width: 2rem;
  height: 1.4rem;
  padding: 0 0.3rem;
  border-radius: 0.3rem;
  color: #fff;
  font-size: 0.55rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.courier-name {
  width: 4.5rem;
  margin-left: 0.6rem;
}

.courier-percent {
  min-width: 2.6rem;
  text-align: right;
}
</style>
